<template>
  <div class="vh-flex">
    
    <SimpleOptionSelectorField class="ops-item" @itemClick="finishWaitConfirmChange" name="拼完等待确认" :curkey="finishWaitConfirmKey" :options="enableOptions"></SimpleOptionSelectorField>
    <SimpleOptionSelectorField class="ops-item" @itemClick="symbolVisibleChange" name="音标显示" :curkey="symbolVisibleKey" :options="visibleOptions"></SimpleOptionSelectorField>
    <SimpleOptionSelectorField class="ops-item" @itemClick="autoPlayChange" name="自动播放发音" :curkey="autoPlayKey" :options="autoPlayOptions"></SimpleOptionSelectorField>
    <SimpleOptionSelectorField class="ops-item" @itemClick="loopModeChange" name="切换方式" :curkey="loopModeKey" :options="loopModeOptions"></SimpleOptionSelectorField>
  </div>
</template>

<script>
import SimpleOptionSelectorField from '@/components/SimpleOptionSelectorField.vue';
import spellConfig from '@/commom/config/SpellConfig'
export default {
  name: 'SpellBasicConfig',
  components: {
    SimpleOptionSelectorField
  },
  props: {
    
  },
  data(){
    return {
        config:null,
        autoPlayKey:"0",
        finishWaitConfirmKey:"0",
        symbolVisibleKey:"show",
        loopModeKey:"order",
        autoPlayOptions:[
            {name:"关闭",key:"0"},
            {name:"1次",key:"1"},
            {name:"2次",key:"2"},
            {name:"3次",key:"3"}
        ],
        enableOptions:[
            {name:"关闭",key:"0"},
            {name:"开启",key:"1"}
        ],
        visibleOptions:[
            {name:"显示",key:"show"},
            {name:"隐藏",key:"hide"}
        ],
        loopModeOptions:[
            {name:"顺序切换",key:"order"},
            {name:"重复2遍",key:"loop2"},
            {name:"重复3遍",key:"loop3"},
            {name:"重复4遍",key:"loop4"},
            {name:"重复5遍",key:"loop5"},
            {name:"无限重复",key:"loop"}
            
        ]
    }
  },
  ///挂载完成
  mounted:function(){
    this.config = spellConfig.getConfig()
    this.autoPlayKey = this.config.basic.autoPlay
    this.finishWaitConfirmKey = this.config.basic.finishWaitConfirm
    this.symbolVisibleKey = this.config.basic.symbolVisible
    this.loopModeKey = this.config.basic.loopMode

  },
  methods:{
    ///自动播放改变
    autoPlayChange:function(ops){
      this.autoPlayKey = ops.key
      this.config.basic.autoPlay = ops.key
      spellConfig.saveConfig()
    },
    ///完成等待确认改变
    finishWaitConfirmChange:function(ops){
      this.finishWaitConfirmKey = ops.key
      this.config.basic.finishWaitConfirm = ops.key
      spellConfig.saveConfig()
    },
    ///音标显示改变
    symbolVisibleChange:function(ops){
      this.symbolVisibleKey = ops.key
      this.config.basic.symbolVisible = ops.key
      spellConfig.saveConfig()
    },
    ///切换方式改变
    loopModeChange:function(ops){
      this.loopModeKey = ops.key
      this.config.basic.loopMode = ops.key
      spellConfig.saveConfig()
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ops-item{
    margin-bottom: 15px;
}
</style>
